module.exports = __webpack_public_path__ + "media/pl_pl_s1_Antek.1edf3325.oga";